import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["styles", "color", "triggerIcon", "triggerLabel", "triggerAriaLabel", "intl"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { applyStylingHoc } from '../../lib/styling.js';
import Button from '../Button/index.js';
import messages from './OffCanvas.lang.js';
export var Trigger = /*#__PURE__*/function (_PureComponent) {
  _inherits(Trigger, _PureComponent);

  var _super = _createSuper(Trigger);

  function Trigger(props) {
    var _this;

    _classCallCheck(this, Trigger);

    _this = _super.call(this, props);

    _this.handleHoverToggle = function () {
      _this.setState({
        hover: !_this.state.hover
      });
    };

    _this.state = {
      hover: false
    };
    return _this;
  }

  _createClass(Trigger, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          styles = _this$props.styles,
          color = _this$props.color,
          triggerIcon = _this$props.triggerIcon,
          triggerLabel = _this$props.triggerLabel,
          triggerAriaLabel = _this$props.triggerAriaLabel,
          formatMessage = _this$props.intl.formatMessage,
          rest = _objectWithoutProperties(_this$props, _excluded);

      return React.createElement(Button, _objectSpread({
        styles: styles.root,
        className: classNames((_classNames = {}, _defineProperty(_classNames, styles['has-customIcon'], triggerIcon), _defineProperty(_classNames, styles['is-hover'], this.state.hover), _classNames)),
        color: color,
        icon: triggerIcon,
        onClick: this.props.onClick,
        onMouseEnter: this.handleHoverToggle,
        onMouseLeave: this.handleHoverToggle,
        "aria-label": triggerAriaLabel ? triggerAriaLabel : !triggerLabel ? formatMessage(messages.openBtnAriaLabel) : null
      }, rest), triggerLabel);
    }
  }]);

  return Trigger;
}(PureComponent);
Trigger.defaultProps = {
  triggerIcon: 'icon-menu',
  color: 'default',
  styles: {}
};
export default injectIntl(applyStylingHoc({})(Trigger));